import { FAQSContainer } from "../../containers";
import './style.scss'

function FAQS() {
    return (
        <div id="FAQS">
            <FAQSContainer />
        </div>
    );
}
export default FAQS;